module.exports = __webpack_public_path__ + "img/Adobe_Premiere-icon.ee9c3811.png";